import React from 'react';
import AsyncSelect from "react-select/async";
import {useAppDispatch} from "../../../app/store";
import {ADMIN_LANG} from "../../../settings";
import {PlainDetails} from "../../../types/admin";
import {getPlainThemes} from "../../../app/slices/admin";

interface AsyncThemeSelectProps {
    onChange: (value: PlainDetails) => void;
    initialValue: PlainDetails | null;
    defaultOptions: PlainDetails[] | [];
}

const AsyncThemeSelect = ({onChange, initialValue, defaultOptions}: AsyncThemeSelectProps) => {
    const dispatch = useAppDispatch();

    const loadOptions = (input: string) => {
        return new Promise<PlainDetails[]>((resolve) => {
            if (input.length < 2) {
                return resolve([]);
            }

            dispatch(getPlainThemes(input))
                .then((fulfilledAction) => {
                    const data: PlainDetails[] = fulfilledAction.payload.themes;
                    resolve(data);
                })
                .catch(() => resolve([]));
        });
    };

    return (
        <AsyncSelect
            value={initialValue}
            cacheOptions
            defaultOptions={defaultOptions}
            loadOptions={loadOptions}
            noOptionsMessage={() => ADMIN_LANG.no_options}
            onChange={(selectedValue) => onChange(selectedValue as PlainDetails)}
            placeholder={ADMIN_LANG.select_theme}
            classNamePrefix="react-select"
            className="custom-react-select"
        />
    );
};

export default AsyncThemeSelect;